<template>
  <tk-container class="login">
    <tkui-header center slot="header">
      登录
    </tkui-header>
    <tkui-input v-model="account " placeHolder="请输入账号">
      <tk-icon slot="before">mobile_phone</tk-icon>
      <!--<span slot="after" @click="getCode">-->
        <!--{{num > 0 && num < 250 ? Math.floor(num/10) + 's重新发送' : '获取验证码'}}-->
      <!--</span>-->
    </tkui-input>
    <tkui-input v-model="code" placeHolder="请输入密码" type="password">
      <tk-icon slot="before">password</tk-icon>
    </tkui-input>
    <div class="btnBox">
      <tkui-button class="block raised primary rounded" @click.native="login">登录</tkui-button>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        account: '',
        code: '',
        num: 250
      }
    },
    methods: {
      async login () {
        if (!this.account || this.account === '') {
          this.$tkGlobal.toast.add('账号不能为空')
          return
        }
        if (!this.code || this.code === '') {
          this.$tkGlobal.toast.add('请输入密码')
          return
        }
        try {
          let res = await this.$tkParse.post('/login', {
            'username': this.account,
            'password': this.code
          })
          res.data.avatar = res.data.avatar || ''
          if (res) {
            this.$store.commit('setUser', res.data)
            this.$store.commit('setSessionToken', res.data.sessionToken)
            this.$tkAjaxGlobal.headers['X-Parse-Session-Token'] = res.data.sessionToken
          }
          this.$replace('/')
          this.tel = ''
          this.code = ''
        } catch (e) {
          this.$tkGlobal.toast.add(e.data.error)
        }
      },
      async getCode () {
        if (!this.tel || this.tel === '') {
          this.$tkGlobal.toast.add('手机号不能为空')
          return
        }
        if (this.num !== 250) this.num = 249
        if (this.time) {
          clearInterval(this.time)
        }
        this.time = setInterval(() => {
          this.num --
          if (this.num <= 0) {
            clearInterval(this.time)
            this.num = 250
          }
        }, 100)
        try {
          await this.$tkParse.post('/sms/sendCode', {
            'phone': this.tel,
            'templateId': 'qJ6VQ'
          })
          this.$tkGlobal.toast.add('验证码已发送,请查收')
        } catch (e) {
          this.$tkGlobal.toast.add('验证码获取失败,请重试')
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.login{
  background: #ffffff;
  .btnBox{
    padding: 0 15px;
    margin: 30px auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/app/login/login.vue